var map = {
	"./033-bm.webp": 1229,
	"./033-cn.webp": 1230,
	"./033.webp": 1231,
	"./13-bm.webp": 1232,
	"./13-cn.webp": 1233,
	"./13.webp": 1234,
	"./3-bm.webp": 1235,
	"./3-cn.webp": 1236,
	"./3.webp": 1237,
	"./angpao-bm.webp": 1238,
	"./angpao-cn.webp": 1239,
	"./angpao.webp": 1240
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1228;